export const USER_DETAIL = 'USER_DETAIL';
